import React, {Component} from 'react'
import AppHeader from "../Misc/AppHeader";
import {BASE_URL_2} from "../../server/constants";
import {findByMail} from '../../server/actions'
import {BeatLoader} from 'react-spinners';
import {Link} from 'react-router-dom';
import Logo from './logo';
import './login.css';


class forgotPassword extends Component {
    constructor() {
        super()
        this.state = {
            mail: '',
            loading: false
        }
    }

    handleSubmit(event) {
        this.setState({loading:true})
        event.preventDefault();
        let data = {};
        data["username"] = this.state.mail;

        findByMail(this.state.mail).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(response => {
            if (response === false) {
                console.log("came here")
                fetch(BASE_URL_2 + '/forgotPassword', {
                    method: 'post',
                    body: JSON.stringify(data),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }).then((response) => {
                    if (response.status===417)
                    {
                        alert('Your account is inactive Please Contact admin')
                        throw Error(response.statusText);
                    }
                    else if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    document.getElementById("message").style.color = "red";
                    document.getElementById("message").innerHTML = "Your password reset link has been sent to you registered email id";
                    document.getElementById("submit").disabled = true;
                    console.log(data);
                    this.setState({loading:false})
                }).catch(
                    (error) => {
                        this.setState({loading:false})
                        console.log(' response', error)
                    }
                )
            } else {
                this.setState({loading:false})
                document.getElementById("message").style.color = "red";
                document.getElementById("message").innerHTML = "This email id is not registered";
            }

        }).catch(
            (error) => {
                this.setState({loading:false})
                console.log(' response', error)
            }
        )
    }

    onChange(e) {
        this.state.mail = e.target.value;
    }

    render() {
        return (
            <div>
                {/* <AppHeader/> */}
                <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div>
                    <section className="mainContent full-width clearfix" style={{padding:'0px'}}>
                        <div className='row' style={{overflowY:'scroll', overflowX:'hidden',height:'calc(100vh - 70px)'}}>
                            <div className='col-lg-7 col-md-6 col-sm-12 loginBackground'>
                            </div>
                            <div className='col-lg-5 col-md-6 col-sm-12'>
                                <div className='row'>
                                    <div className='col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1'>
                                        <Logo />
                                        <form className="reset-form" onSubmit={this.handleSubmit.bind(this)}>
                                            <div className="panel panel-default formPanel">
                                                <div className="panel-heading bg-color-1 border-color-1">
                                                    <h3 className="panel-title">Enter registered Email ID</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <div className="form-group formField">
                                                        <input type="email" className="form-control"
                                                            name="email" onChange={(e) => this.onChange(e)} required/>
                                                    </div>
                                                    <div className="form-group formField" style={{display:'block'}}>
                                                    <span id="message"></span>
                                                    </div>
                                                    <div className="form-group formField forgotpwd-form-group">
                                                        <Link to='/login'><button class="btn btn-back-primary btn-sm pull-left" id="">Back</button></Link>
                                                        <button class="btn btn-primary btn-sm pull-right" id="submit" type="submit">Submit</button>
                                                    </div>                             
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        );
    }

}

export default forgotPassword;


// WEBPACK FOOTER //
// ./src/components/Auth/forgotPassword.jsx